import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { usersKey } from './queryKeys';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
import envVars from '../../../constants/envVars';
const useUpdateUserEmail = (id) => {
    const queryClient = useQueryClient();
    const params = useQueryRequestParams();
    return useMutation({
        mutationFn: (attributes) => axios.post(`${envVars.API_CLOUD_HOSTNAME}backoffice/update-email/`, { user_id: id, ...attributes }, params),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [usersKey, id] });
        }
    });
};
export default useUpdateUserEmail;
